module.exports = __webpack_public_path__ + "static/media/share.d797dc0f.svg";